/*!
 * Copyright © 2019-2026. Verizon Connect Ireland Limited. All rights reserved.
 */

export const FEATURE_TOGGLES = {
  ClusteringByDefault: 'LiveMap_ClusteringByDefault',
  OverrideTowingPoc: 'LiveMap_OverrideTowingPoc',
  PingMVPChanges: 'LiveMap_PingMVPChanges',
  SelfServiceExperimentIssueBadge: 'LiveMap_SelfServiceExperiment_IssueBadge',
  SelfServiceExperimentIconWithError: 'LiveMap_SelfServiceExperiment_IconWithError',
  FleetAndDeviceList: 'DISS_FDL_FLEET_DEVICE_LIST_ENABLED',
  AttributeFilter: 'LiveMap_AttributesFiltering',
  EcmEnabled: 'LiveMap_ECM_Enabled'
};
